import styled from 'styled-components';
import Image from 'next/image';

import { getThemeColor, getThemePath, media } from '@utils/styled';

import Typography from '@common/components/Typography';

export const Wrapper = styled.div`
  ${({ theme, spacingTop }) =>
    spacingTop && theme.getFluidSpacing('margin-top', ...spacingTop)}
  ${({ theme, spacingBottom }) =>
    spacingBottom && theme.getFluidSpacing('margin-bottom', ...spacingBottom)}
  border-radius: ${getThemePath(['borderRadiuses', 'normal.2'])}rem;
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'scale', 3)}
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'widthBased', 2)}
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'scale', 3)}
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'widthBased', 2)}
  background-color: ${getThemeColor('bluegrey.95')};

  ${media.from960up`
    display: flex;
    flex-wrap: wrap;
    gap: 3rem;
  `}
`;

export const Section = styled.div`
  flex: 1;
  width: 100%;

  &:not(:only-child):first-of-type {
    margin-bottom: 3.5rem;
  }

  ${media.from960up`
    width: 50%;

    &:first-child {
      ${({ theme }) => theme.getFluidAttribute('min-width', 40, 50)};
      margin-bottom: 0;
    }

    &:not(:only-child):first-of-type {
      margin-bottom: 0;
    }
  `}

  ${media.from1440up`
    &:first-child {
      ${({ theme }) => theme.getFluidAttribute('min-width', 45, 55)};
    }
  `}
`;

export const Title = styled(Typography).attrs({
  variant: 'h6',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 5)}
`;

export const PaymentMethodsWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
  gap: 1rem;
`;

export const PaymentMethodIcon = styled(Image)`
  justify-self: center;
  border: 0.2rem solid ${getThemeColor('bluegrey.90')} !important;
  border-radius: 0.5rem;
  object-fit: cover;
`;

export const DeliveryTermsWrapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 3)}
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'equal', 3, true)}
  border-top: 0.1rem solid ${getThemeColor('bluegrey.80')};
`;

export const DeliveryTerms = styled(Typography).attrs({
  customAs: 'a',
  variant: 'body2',
})`
  display: inline-block;
  margin: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 3)}
  color: ${getThemeColor('bluegrey.60')};
`;
